module.exports = __webpack_public_path__ + "img/pensions-calculator.e8324d56.svg";